import { Document, Page, Image, StyleSheet, View, Text, Font } from '@react-pdf/renderer'
var moment = require('moment');

Font.register({
    // family: 'PlusJakartaSans',
    // fonts: [
    //     {
    //         src: `./fonts/PlusJakartaSans-Regular.ttf`
    //     },
    //     {
    //         src: `./fonts/PlusJakartaSans-Bold.ttf`,
    //         fontWeight: 'bold'
    //     },
    //     {
    //         src: `./fonts/PlusJakartaSans-Italic.ttf`,
    //         fontWeight: 'normal',
    //         fontStyle: 'italic'
    //     },
    //     {
    //         src: `./fonts/PlusJakartaSans-BoldItalic.ttf`,
    //         fontWeight: 'bold',
    //         fontStyle: 'italic'
    //     }
    // ]
    family: 'Arial',
    fonts: [
        {
            src: `./fonts/Arial-Regular.ttf`
        },
        {
            src: `./fonts/Arial-Bold.ttf`,
            fontWeight: 'bold'
        },
        {
            src: `./fonts/Arial-Italic.ttf`,
            fontWeight: 'normal',
            fontStyle: 'italic'
        },
        {
            src: `./fonts/Arial-BoldItalic.ttf`,
            fontWeight: 'bold',
            fontStyle: 'italic'
        }
    ]
})

const styles = StyleSheet.create({
    page: { fontFamily: 'Arial', backgroundColor: '#fff' },
    frontPage: { flex: 1, flexDirection: "column", justifyContent: "space-around", alignItems: "center", textAlign: 'center', margin: 30, marginBottom: 0 },
    reportTitle: { fontSize: 20, color: '#566a7f', marginTop: '30px', fontWeight: 600, },
    tableOfContentsHeading: { fontSize: 14, color: '#566a7f' },
    logo: { width: '260px' },
    subjectName: { fontSize: '16px', fontWeight: 600, color: '#566a7f', marginBottom: 5, },
    orgName: { fontSize: '12px', color: '#566a7f' },
    layout: { margin: "30px", },
    tableOfContents: { height: "600px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", },
    tableOfContentsList: { width: "80%", display: "flex", flexDirection: "row", justifyContent: "space-between", padding: "15px", borderBottom: "1px solid #eee", },
    mb2: { marginBottom: "20px" },
    mt2: { marginTop: "20px" },
    pt1: { paddingTop: "10px" },
    pt2: { paddingTop: "20px" },
    pt3: { paddingTop: "30px" },
    introduction: { padding: "3% 5%", position: "relative" },
    introduction2: { padding: "3% 5%", position: "relative" },
    introductionHeading: { color: "#566a7f", marginBottom: "6px", },
    introductionHeadingBorder: { width: "100%", height: "2px", backgroundColor: "#45A7C4", marginBottom: "20px", },
    paraText: { marginTop: 0, marginBottom: "15px", fontSize: 12, color: "#697a8d", fontWeight: 500, lineHeight: "1.5" },
    paraHeading: { marginTop: "20px", marginBottom: "10px", fontSize: 14, fontWeight: 700, },
    ratersTable: { width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", padding: "5px 0px", borderBottom: "1px solid #eee", },
    ratersTableContent: { fontSize: "11px", color: "#697a8d", fontWeight: 400, },
    strengthListHeader: { width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", backgroundColor: "#3fa8c6", padding: "10px 0px", borderRadius: "2px", },
    strengthList: { width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", borderBottom: "1px solid #eee", padding: "10px 0px", },
    strengthListHeading: { width: "80%", margin: 0, padding: 0, fontSize: "10px", fontWeight: "500", lineHeight: "1.5", color: "#566a7f", display: "flex", justifyContent: "center", alignItems: "center", },
    strengthListScore: { width: "25px", height: "25px", paddingTop: "7px", backgroundColor: "#3fa8c6", display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", color: "#fff", fontSize: "9px", fontWeight: "bold", borderRadius: "50%" },
    SlSelf: { fontSize: "10px", color: "#fff", marginRight: "18px", },
    questionSection: { padding: "5px", },
    questionSectionQue: { marginTop: "10px", marginBottom: "8px", fontSize: "13px", color: "#566a7f", lineHeight: "1.5", fontWeight: 700, },
    questionSectionAns: { paddingBottom: "10px", fontSize: "11px", color: "#697a8d", lineHeight: "1.5", },
    answerSection: { width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start", padding: "10px 0", borderBottom: "1px solid #f2f2f2", },
    answerSectionGroupName: { width: "20%", fontSize: "11px", color: "#697a8d", lineHeight: "1.5" },
    answerSectionGroupAnswer: { width: "80%" },
    opinionScaleView: { display: "flex", flexDirection: "row", justifyContent: "flex-start" },
    ssimg: { width: '450px', textAlign: 'center' },
    spantext: { textAlign: 'center', color: '#566a7f', padding: '20px', fontSize: '11px' },
    ratingthead: { fontSize: 10, fontWeight: 600, paddingLeft: 5, paddingRight: 5, color: '#566a7f' },
    ratingtbody: { fontSize: 10, padding: 0, paddingLeft: 5, paddingRight: 5, color: '#566a7f', },
    w480: { width: 480 },
    w33: { width: '33.33%' },
    ratingtbodygap: { color: 'rgb(255, 62, 29)', fontWeight: 800 },
    green: { color: 'rgb(40, 167, 69)', fontWeight: 800 },
    tableflex1: { flex: 1 },
    tableflex2: { flex: 2 },
    tableflex3: { flex: 3 },
    tablefw: { fontWeight: 600, color: '#566a7f', fontSize: "12px" },
    questionText: { fontWeight: 500, color: '#566a7f', fontSize: 10, marginTop: 'auto', marginBottom: 'auto', paddingRight: 10 },
    competencyComments: { padding: "10% 0 10% 0" },
    competencyComments2: { padding: "3.5% 0 10% 0" },
    pageSubHeading: { color: "#566a7f", fontSize: "14px", marginBottom: "15px" },
    rjPageSubHeading: { color: "#566a7f", fontSize: 14, fontWeight: 800, marginBottom: "0px" },
    competencyCommentsQuestion: { backgroundColor: "#f1f2f3", color: "#777", fontSize: 12, marginBottom: "15px", padding: "10px", },
    competencyCommentsAnswer: { color: "#566a7f", fontSize: 10, lineHeight: '1.5px', },
    textAlignCenter: { textAlign: "center", display: "flex", alignItems: "center" },
    textAlignRight: { textAlign: "right", display: "flex", alignItems: "right" },
    pageCount: { position: "absolute", bottom: 20, left: 0, right: 0, textAlign: "center", },
    pageCountText: {  color: "#566a7f", fontSize: "11px", fontWeight: 500 },
    ratingPoint: { fontWeight: 600, color: '#566a7f', paddingTop: '5px' },
    success: { backgroundColor: 'green', color: '#fff' },
    danger: { backgroundColor: 'red', color: '#fff' },
    w7: { width: '2%' },
    w10: { height: '35%' },
    w52: { width: '58%', },
    overallthead: { fontSize: 7, fontWeight: 600, color: '#566a7f', height: '15px', paddingTop: '8px', display: "flex", alignItems: "center", justifyContent: "center", },
    overallbody: { fontSize: 7, color: '#566a7f', padding: '4px 2px', },
    overallTable: { width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", borderBottom: "1px solid #eee" },
    executiveTable: { width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", lineHeight: '3.5px', },
    competencyScoresContentHeading: { display: "flex", flexDirection: "row", justifyContent: "flex-start" },
    competencyScoresContent: { display: "flex", flexDirection: "row", justifyContent: "flex-around" },
    competencyScoresContentMb1: { marginBottom: "5px" },
    competencyScoresHeading: {
        color: "#3fa8c6",
        fontSize: "10px",
        fontWeight: 600
    },
    competencyScoresBlank: {
        width: "20%"
    },
    competencyScoresChart: {
        width: "70%"
    },
    competencyScoresChartTextRight: {
        textAlign: "right"
    },
    competencyScoresChartImage: {
        width: "100%",
    },
    competencyScoresAvg: {
        width: "10%"
    },
    // competencyBreakdownAvgScore: {
    //     marginTop: "5px",
    //     marginBottom: 0,
    //     fontSize: "8px",
    //     fontWeight: 800,
    // },
    competencyBreakdownAvgScore2: {
        marginTop: "12px",
        marginBottom: '-10px',
        fontSize: "8px",
        fontWeight: 800,
    },
    competencyBreakdownAvgScore5: {
        marginTop: "14px",
        marginBottom: '-14px',
        fontSize: "7px",
        fontWeight: 800,
    },
    competencyBreakdownAvgScore6: {
        marginTop: "17px",
        marginBottom: '-16px',
        fontSize: "7px",
        fontWeight: 800,
    },

    competencyoverviewAvgScore6: {
        marginTop: "10px",
        marginBottom: '-4px',
        fontSize: "8px",
        fontWeight: 800,
    },
    competencyoverviewAvgScore5: {
        marginTop: "8px",
        marginBottom: '-4px',
        fontSize: "8.5px",
        fontWeight: 800,
    },
    competencyoverviewAvgScore2: {
        marginTop: "10px",
        marginBottom: 0,
        fontSize: "8px",
        fontWeight: 800,
    },


    competencyScoresAvgScore: {
        marginTop: "2px",
        marginBottom: 0,
        fontSize: "7px"
    },
    rotate: {
        transform: 'rotate(270deg)',
        transformOrigin: 'bottom left',
        textAlign: 'left',
        marginBottom: '20px',
        marginTop: '20px',
    },
    w2: {
        width: '2%'
    },
    w98: {
        width: '98%'
    },
    w3: {
        width: '3%'
    },
    circleLegend: {
        width: "20px",
        height: "5px",
        borderRadius: "10px",
        marginRight: '5px',
    },
    w94: {
        width: '94%'
    },
    ratingText: { fontSize: 11, paddingLeft: 2, paddingRight: 2, color: '#566a7f', },
    blueColor: { color: '#45A7C4' },
    textColor: { color: '#566a7f' },
    grayColor: { color: '#8E8E8E' },
    overallFlex: { display: 'inline', flexDirection: 'row', justifyContent: "flex-start" },
    lastTable: { width: "100%", display: "flex", flexDirection: "row", alignItems: 'flex-start', padding: "10px 0px", },
    lastBulletWidth: { width: '2%', fontSize: 9 },
    lastParaWidth: { width: '98%' },
    w16: { width: '16.67%' },
    w25: { width: '25%' },
    w13: { width: '10%' },
    w11: { width: '11%' },
    w18: { width: '22%' },
    w8: { width: '8%' },
    w1: { width: '1%' },
    fs9: { fontSize: 9 },
    overalltext: { fontSize: 8, padding: '4px 2px', },
    nowrap: { whiteSpace: 'pre-wrap' },
    legendTable: { width: "100%", display: "flex", flexDirection: "row", alignItems: 'center' },
    legendContainer: { width: "100%", display: "flex", flexDirection: "row", alignItems: 'flex-start', flexWrap: 'wrap' },
    mr5px: { marginRight: '3px' },
    fs7: { fontSize: 7 },
    ReviewTable: { width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", lineHeight: '2.5px' },
    textCenter: { textAlign: 'center', },
    fw600: { fontWeight: 600 },
    mb3px: { marginBottom: '3px' },
    openEndedComment: { width: "100%", display: "flex", flexDirection: "row", justifyContent: "flex-start", marginBottom: "10px" }
});

export default function ReportDownloadViewOE({ report, onPageRender, pageNumbers }) {
    return (
        <Document>
            <Page wrap style={styles.page}>
                <View style={styles.frontPage}>
                    {/* <Text style={styles.reportTitle}>{report?.reportTitle}</Text> */}
                    <View style={styles.textAlignCenter}>
                        <Image style={styles.logo} src={process.env.REACT_APP_BASE_URL + "assets/img/first-feedback-logo.png"} />
                        <Text style={styles.subjectName}>{report?.subjectName}</Text>
                        {/* <Text style={styles.orgName}>{report?.organizationName}</Text> */}
                        <Text style={styles.orgName}>{moment(new Date()).format('MMMM  DD, YYYY')}</Text>
                    </View>
                    <Image style={styles.ssimg} src={process.env.REACT_APP_BASE_URL + "assets/img/5.png"} />
                    <Text style={styles.spantext}>This report is confidential and should not be distributed without permission.</Text>
                </View>
            </Page>
            <Page wrap style={styles.page}>
                <View style={styles.tableOfContents}>
                    <Text style={[styles.reportTitle, styles.mb2]}>Table of Contents</Text>
                    {
                        report.reportContents !== null ? report.reportContents.map((reportContent, index) => {
                            const pageInfo = pageNumbers?.current[reportContent.name];
                            const pageRange = pageInfo
                            ? pageInfo.start === pageInfo.end
                                ? `${pageInfo.start}`
                                : `${pageInfo.start} - ${pageInfo.end}`
                            : 'Loading...';
                            return (
                                <View style={[styles.tableOfContentsList, index === 0 ? styles.mt2 : '']}>
                                    <Text style={styles.tableOfContentsHeading}>{reportContent.name}</Text>
                                    <Text style={styles.tableOfContentsHeading}>{pageRange}</Text>
                                </View>
                            )
                        }) : <></>
                    }                    
                </View>
            </Page>
            {
                report.reportContents !== null && report.reportContents.find(item => item.name === "Introduction") ? 
                <Page wrap style={styles.page}>
                    <View style={styles.introduction}>
                        <Text render={onPageRender ? onPageRender("Introduction") : undefined} fixed />
                        <Text style={styles.introductionHeading}>Introduction</Text>
                        <Text style={styles.introductionHeadingBorder}></Text>
                        <Text style={styles.paraText}>Welcome to your ClearPoint360 feedback report!</Text>
                        <Text style={styles.paraText}>This detailed report is crafted to give you a well-rounded view of your professional strengths, areas where you can improve, and the overall impact you have on your team and colleagues across the organization. By carefully analyzing the insights provided, you'll be able to pinpoint key areas to prioritize for your ongoing professional development and career advancement. This report serves as a valuable tool to guide your growth, helping enhance your understanding of your leadership approach and potential impact.</Text>
                        <Text style={[styles.paraHeading, styles.blueColor]}>Respondent Statistics</Text>
                        <Text style={styles.paraText}>This section shows a summary of the # of Raters who were invited to provide input and # of Raters who responded in each Rater Group. Feedback is anonymous.</Text>
                        <View style={styles.ratersTable}>
                            <Text style={[styles.w33, styles.tablefw]}>Rater Group</Text>
                            <Text style={[styles.w33, styles.tablefw, styles.textAlignCenter]}>Completed/Invited</Text>
                            <Text style={[styles.w33, styles.tablefw, styles.textAlignRight]}>% Complete</Text>
                        </View>
                        {
                            report?.raters && Object.keys(report.raters).map((value, index) => {
                                return (
                                    <View key={"raterGroup_" + index} style={styles.ratersTable}>
                                        <Text style={[styles.ratersTableContent, styles.w33]}>{value}</Text>
                                        <Text style={[styles.ratersTableContent, styles.w33, styles.textAlignCenter]}>{report.raters[value]['responded']}/{report.raters[value]['total']}</Text>
                                        <Text style={[styles.ratersTableContent, styles.w33, styles.textAlignRight]}>{Math.round((report.raters[value]['responded'] / report.raters[value]['total']) * 100)}%</Text>
                                    </View>
                                )
                            })
                        }
                    </View>
                    <View style={styles.pageCount} fixed>
                        <Text style={styles.pageCountText} render={({ pageNumber, totalPages }) => (
                            `${pageNumber}`
                        )} />
                    </View>
                </Page>
                : ''
            }

            {
                report.reportContents !== null && report.reportContents.find(item => item.name === "Competency Breakout - Insights") ? 
                <Page wrap style={[styles.page, {paddingTop: 20, paddingBottom: 50, paddingHorizontal: 30}]}>
                    {
                        report?.competencyBreakdown && report.competencyBreakdown.map((competency, index) => {
                            return (
                                <View key={"breakdown_" + index}>
                                        <Text render={onPageRender ? onPageRender("Competency Breakout - Insights") : undefined} fixed />
                                        <Text style={styles.introductionHeading}>Competency Breakout - Insights</Text>
                                        <Text style={styles.introductionHeadingBorder}></Text>
                                        <Text style={styles.paraText}>The Competency Breakout – Insights is a summary of open-feedback on your performance of this Competency. This information enables you to understand- directly from your Raters who work with you day to day - how they observe and experience your performance of this competency.</Text>
                                        <Text style={[styles.rjPageSubHeading, styles.blueColor, { marginBottom: '5px' }]}>{competency.name} Feedback</Text>
                                        {
                                            competency.openEnded.map((openEnded, oeIndex) => {
                                                return (
                                                    <View key={"oeIndex_" + oeIndex} break={oeIndex > 0 ? true : false}>
                                                        <Text style={[styles.competencyCommentsQuestion]}>{openEnded.question.replace(/SUBJECT_FIRST_NAME/g, report.subjectFirstName).replace(/ORGANIZATION/g, report.organizationName).replace(/PRONOUN/g, report.subjectPreferredPronoun)}</Text>
                                                        {
                                                            openEnded.answers.map((answer, oeaIndex) => {
                                                                return (
                                                                    <View wrap={false} key={"oeaIndex_" + oeaIndex} style={[styles.openEndedComment]}>
                                                                        <Text style={[styles.competencyCommentsAnswer, {paddingRight: "8px"}]}>&#x2022;</Text>
                                                                        <Text style={[styles.competencyCommentsAnswer, styles.w98]}>{answer.answer} {`(${answer.subject_rater && answer.subject_rater.raterGroup.name ? answer.subject_rater.raterGroup.name.split(' ').map(word => word.charAt(0)).join('') : ''})`}</Text>
                                                                    </View>
                                                                )
                                                            })
                                                        }
                                                    </View>
                                                )
                                            })
                                        }
                                </View>
                            )
                        })
                    }
                    <View style={styles.pageCount} fixed>
                        <Text style={styles.pageCountText} render={({ pageNumber, totalPages }) => (
                            `${pageNumber}`
                        )} />
                    </View>
                </Page>
                : ''
            }
            
            
            
            {
                report.reportContents !== null && report.reportContents.find(item => item.name === "Processing Your 360-Degree Feedback") ? 
                <Page wrap style={styles.page}>
                    <View style={styles.introduction}>
                        <Text render={onPageRender ? onPageRender("Processing Your 360-Degree Feedback") : undefined} fixed />
                        <Text style={styles.introductionHeading}>Processing Your 360-Degree Feedback</Text>
                        <Text style={styles.introductionHeadingBorder}></Text>
                        <Text style={styles.paraText}>Receiving 360-degree feedback can be both enlightening and challenging. It’s natural to feel a range of emotions as you review the insights provided by your peers, direct reports, and managers. However, to make the most of this feedback, it's important to approach it with an open mind and a willingness to learn. Here are some best practices and suggestions to help you process your feedback effectively:</Text>
                        
                        <View style={[styles.lastTable]}>
                            <Text style={[styles.lastBulletWidth, styles.textColor, styles.fs12]}>&#8226;</Text>
                            <Text style={[styles.ratingtbody, styles.fs10]}>
                                <Text style={{fontWeight: 600}}>Acknowledge Your Initial Reactions: </Text>
                                It’s common to have an emotional response to feedback, especially if it’s unexpected or critical. Take a moment to recognize how you’re feeling without reacting impulsively. This emotional awareness will help you approach the feedback more objectively.
                            </Text>
                        </View>
                        <View style={[styles.lastTable]}>
                            <Text style={[styles.lastBulletWidth, styles.textColor, styles.fs12]}>&#8226;</Text>
                            <Text style={[styles.ratingtbody, styles.fs10]}>
                                <Text style={{fontWeight: 600}}>Balance Positive and Constructive Feedback: </Text>
                                People often tend to focus more on negative or constructive feedback, sometimes at the expense of overlooking positive feedback. Make sure to give equal weight to both. Your strengths are just as important as your areas for improvement and can serve as a foundation for further growth.
                            </Text>
                        </View>
                        <View style={[styles.lastTable]}>
                            <Text style={[styles.lastBulletWidth, styles.textColor, styles.fs12]}>&#8226;</Text>
                            <Text style={[styles.ratingtbody, styles.fs10]}>
                                <Text style={{fontWeight: 600}}>Avoid Dismissing Feedback You Disagree With: </Text>
                                It’s tempting to disregard feedback that doesn’t align with your self-perception. Instead of dismissing it, take time to reflect on it. Ask yourself why someone might see you in that light and whether there’s an opportunity to learn from their perspective.
                            </Text>
                        </View>
                        <View style={[styles.lastTable]}>
                            <Text style={[styles.lastBulletWidth, styles.textColor, styles.fs12]}>&#8226;</Text>
                            <Text style={[styles.ratingtbody, styles.fs10]}>
                                <Text style={{fontWeight: 600}}>Look for Patterns and Themes: </Text>
                                Pay attention to recurring themes in your feedback. If multiple raters are pointing out the same strengths or opportunities, this is a clear signal that these areas are significant to your overall performance. Patterns can also help you prioritize which areas to focus on first.
                            </Text>
                        </View>
                        <View style={[styles.lastTable]}>
                            <Text style={[styles.lastBulletWidth, styles.textColor, styles.fs12]}>&#8226;</Text>
                            <Text style={[styles.ratingtbody, styles.fs10]}>
                                <Text style={{fontWeight: 600}}>Seek Clarification When Needed: </Text>
                                If there are aspects of the feedback that are unclear or surprising, consider discussing them with your manager or a trusted colleague. Sometimes additional context can provide a deeper understanding and help you better interpret the feedback.
                            </Text>
                        </View>

                    </View>
                    <View style={styles.pageCount} fixed>
                        <Text style={styles.pageCountText} render={({ pageNumber, totalPages }) => (
                            `${pageNumber}`
                        )} />
                    </View>
                </Page>
                : ''
            }

            {
                report.reportContents !== null && report.reportContents.find(item => item.name === "Next Steps") ? 
                <Page wrap style={styles.page}>
                    <View style={styles.introduction}>
                        <Text render={onPageRender ? onPageRender("Next Steps") : undefined} fixed />
                        <Text style={styles.introductionHeading}>Next Steps</Text>
                        <Text style={styles.introductionHeadingBorder}></Text>
                        <Text style={[styles.paraText, { fontWeight: 600 }]}>Now that you’ve reviewed the report it’s important to harness your energy around the feedback and start identifying your priorities you wish to translate into action.  Here are some best practices and suggestions to help you organize your thoughts into effective and actionable steps:</Text>

                        <View style={styles.lastTable}>
                            <Text style={[styles.lastBulletWidth, styles.textColor, styles.fs10]}>1.</Text>
                            <Text style={[styles.ratingtbody, styles.fs10]}>
                                <Text style={{fontWeight: 600}}>Take Time to Reflect: </Text>
                                After reading through the feedback, step away for a short period. This break allows you to process your initial emotional reactions and come back with a clearer mindset.
                            </Text>
                        </View>
                        <View style={styles.lastTable}>
                            <Text style={[styles.lastBulletWidth, styles.textColor, styles.fs10]}>2.</Text>
                            <Text style={[styles.ratingtbody, styles.fs10]}>
                                <Text style={{fontWeight: 600}}>Review the Feedback Holistically: </Text>
                                Go through the entire report once again, focusing on both strengths and areas for development. Look at the feedback from different rater groups to understand the diverse perspectives.
                            </Text>
                        </View>
                        <View style={styles.lastTable}>
                            <Text style={[styles.lastBulletWidth, styles.textColor, styles.fs10]}>3.</Text>
                            <Text style={[styles.ratingtbody, styles.fs10]}>
                                <Text style={{fontWeight: 600}}>Identify Key Takeaways: </Text>
                                Highlight the most important points, particularly those that are repeated across different sections or rater groups. These are likely the areas that need your attention the most.
                            </Text>
                        </View>
                        <View style={styles.lastTable}>
                            <Text style={[styles.lastBulletWidth, styles.textColor, styles.fs10]}>4.</Text>
                            <Text style={[styles.ratingtbody, styles.fs10]}>
                                <Text style={{fontWeight: 600}}>Create an Action Plan: </Text>
                                Based on the feedback, develop a plan to capitalize on your strengths and address your opportunities for growth. Set specific, measurable goals with timelines to help you stay on track.
                            </Text>
                        </View>
                        <View style={styles.lastTable}>
                            <Text style={[styles.lastBulletWidth, styles.textColor, styles.fs10]}>5.</Text>
                            <Text style={[styles.ratingtbody, styles.fs10]}>
                                <Text style={{fontWeight: 600}}>Follow Up: </Text>
                                Share your action plan with your manager or a mentor and seek their support in your development journey. Regularly check in on your progress and adjust your plan as needed based on ongoing feedback and self-reflection.
                            </Text>
                        </View>
                        <Text style={[styles.paraText, { marginTop: '15px' }]}>By following these steps and embracing a growth mindset, you can turn your 360-degree feedback into a powerful tool for exponential personal and professional growth. Remember, receiving feedback is an opportunity to elevate your performance and potential. How you choose to respond to it will significantly shape your future success. May you find inspiration in this simple yet powerful quote from William James – a renowned thought leader in psychology and philosophy - “Act as if what you do makes a difference. It does.”</Text>
                    </View>
                    <View style={styles.pageCount} fixed>
                        <Text style={styles.pageCountText} render={({ pageNumber, totalPages }) => (
                            `${pageNumber}`
                        )} />
                    </View>
                </Page>
                : ''
            }
            
        </Document>
    )
}